
import { defineComponent, PropType, computed } from "vue";
import { useRouter } from "vue-router/composables";

export default defineComponent({
  name: "CiContentHubTile",
  props: {
    contentRoute: {
      type: Object as PropType<ContentHubs.ContentRoute>,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();

    const tags = computed(
      (): ContentHubs.Tag[] =>
        [
          props.contentRoute.tag_level_1,
          props.contentRoute.tag_level_2,
          props.contentRoute.tag_level_3,
          props.contentRoute.tag_level_4,
          props.contentRoute.tag_level_5,
          props.contentRoute.tag_level_6,
        ].filter((n) => n) as ContentHubs.Tag[]
    );

    const contentHub = computed(
      (): ContentHubs.ContentHub | Record<string, string> => props.contentRoute.content_hub || {}
    );

    const handleClick = (): void => {
      router.replace(`/fonds/${props.contentRoute.slug}`).then(() => {
        location.reload();
      });
    };

    return { contentHub, tags, handleClick };
  },
});
